/**
 * Memo attachment utilities.
 */

import { getAppBaseUrl } from '@config/baseUrl';

const IMAGE_EXTS = ['jpg', 'jpeg', 'png'];
const PDF_EXT = 'pdf';

export const getAttachmentUrl = (path: string): string => {
  const base = getAppBaseUrl().replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${base}/storage/${cleanPath}`;
};

export const isImageAttachment = (path: string): boolean =>
  IMAGE_EXTS.some((ext) => path.toLowerCase().endsWith(`.${ext}`));

export const isPdfAttachment = (path: string): boolean =>
  path.toLowerCase().endsWith(`.${PDF_EXT}`);

export const getFileName = (path: string): string => path.split('/').pop() ?? path;
